import { post } from './http'

//社团信息列表
export function getAssociationInfo() {
  return post('/tyapi/pc/AssociationCockpit/getAssociationInfo', {})
}

//社团规模
export function AssociationScale() {
  return post('/tyapi/pc/AssociationCockpit/AssociationScale', {})
}

//社团规模环比
export function AssociationScaleQoq() {
  return post('/tyapi/pc/AssociationCockpit/AssociationScaleQoq', {})
}

//社团纳新活动
export function AssociationRecruitment() {
  return post('/tyapi/pc/AssociationCockpit/AssociationRecruitment', {})
}

//本学期社团活动
export function AssociationActivity() {
  return post('/tyapi/pc/AssociationCockpit/AssociationActivity', {})
}
//本学期社团活动
export function getAssociationNums() {
  return post('/tyapi/pc/AssociationCockpit/getAssociationNums', {})
}

//获取社团基础信息
export function getAssociationInfoBasics(associationId) {
  return post('/tyapi/pc/club/getAssociationInfo', {
    associationId: associationId,
  })
}

//提交申请（社团）
export function submitApplication(data) {
  return post('/tyapi/pc/club/submitApplication', data)
}
